import React from 'react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';
import './coursePack.module.scss';
import PatternLeft from './images/pattern-left-blue.png';
import PatternRight from './images/pattern-right-blue.png';
import SheHirameki from './images/she-hirameki.png';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import classNames from 'classnames';
import RoleModelCard1 from './images/shares-4931237.png';
import RoleModelCard2 from './images/shares-4930613.png';
import RoleModelCard3 from './images/shares-4930461.png';
import {
  CourseSmallBrandingCard,
  CourseSmallCameraCard,
  CourseSmallContentsMarketingCard,
  CourseSmallCopyWritingCard,
  CourseSmallFreelanceCard,
  CourseSmallMarketingFirstCard,
  CourseSmallPrCard,
  CourseSmallSelfBrandingCard,
  CourseSmallSnsMarketingCard,
  CourseSmallWebMarketingCard,
  CourseSmallWorkTrialCard,
  CourseWebWritingCard,
  CourseWritingFirstCard,
} from './CourseCard';
import { V3Routes } from '../../routes';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

@withNavigation(NavigationSpecs.side())
@authenticated
export class WriterPage extends React.Component {
  render() {
    const breadCrumbItems = [{ text: 'コース', to: V3Routes.courses() }, { text: 'ライターセット' }];
    return (
      <>
        <div styleName={classNames('head', 'writer')}>
          <div styleName="head-inner">
            <BreadCrumb items={breadCrumbItems} hasHome />
            <div styleName="head-content">
              <div styleName={classNames('course-title', 'writer')}>ライターセット</div>
              <div styleName="head-detail">
                <div styleName="description">
                  さまざまな分野で活かすことのできる普遍的なライティングスキルを学び、ライターとしてお仕事をするために必要な基礎知識を習得していくセットです。ライティングスキル単体で身につけて活躍される方も、他のスキルを加えて身につけ、お仕事の幅を広げる方もいらっしゃいます。
                </div>
                <div styleName={classNames('comment', 'writer')}>
                  <div styleName="label-box">
                    <div styleName={classNames('label', 'writer')}>こんなひとにおすすめ</div>
                  </div>
                  <img src={SheHirameki} styleName="she-image" />
                  <ul styleName="comment-text">
                    <li>書くことが好き</li>
                    <li>書くことでモノやサービスを広めたい</li>
                    <li>求められた内容を書ける技術がほしい</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div styleName={classNames('content-bg', 'writer')}>
          <div styleName="content">
            <p styleName="title">必修コース</p>
            <p styleName="sub-title">必ず受けておきたいコース</p>
            <div styleName="main-course-list">
              <CourseWritingFirstCard />
              <CourseWebWritingCard />
            </div>
            <div styleName="title">選択コース</div>
            <div styleName="sub-title">なりたい姿に合わせて追加で受けておきたいコース</div>
            <div styleName="pattern-bg">
              <img src={PatternLeft} styleName="pattern-left" />
              <img src={PatternRight} styleName="pattern-right" />
              <div styleName="pattern">
                <div styleName={classNames('label', 'writer')}>先輩シーメイトたちの受講パターン</div>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'writer')}>パターン1</span>
                <span styleName="pattern-text">フリーで場所を問わず活躍できるライターになりたい</span>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'writer')}>パターン2</span>
                <span styleName="pattern-text">書く力を身につけて、ライターとして自分の可能性を広げてみたい</span>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'writer')}>パターン3</span>
                <span styleName="pattern-text">ライターとしてお仕事していくために、最短最速で知識をつけたい</span>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン1</p>
              {GlobalStatesV3.viewport.isSp && (
                <p styleName={classNames('pattern-label', 'writer')}>
                  フリーで場所を問わず活躍できるライターになりたい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isNonSp && (
                  <p styleName={classNames('pattern-label', 'writer')}>
                    フリーで場所を問わず活躍できるライターになりたい
                  </p>
                )}
                <p styleName="description sp-space">
                  ライターとして必要なライティングの知識を備えるためのコースを受講したのち、自分を売り込むためのセルフブランディングやSNS発信の方法も学んでいきます。また、マーケティングの知識も身につけることで、世の中やクライアントから求められていることを的確に理解して記事を書けるようになります。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallSelfBrandingCard />
                      <CourseSmallMarketingFirstCard />
                      <CourseSmallWebMarketingCard />
                      <CourseSmallSnsMarketingCard />
                      <CourseSmallCameraCard />
                      <CourseSmallFreelanceCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4931237" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard1} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン2</p>
              {GlobalStatesV3.viewport.isSp && (
                <p styleName={classNames('pattern-label', 'writer')}>
                  書く力を身につけて、ライターとして自分の可能性を広げてみたい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isNonSp && (
                  <p styleName={classNames('pattern-label', 'writer')}>
                    書く力を身につけて、ライターとして自分の可能性を広げてみたい
                  </p>
                )}
                <p styleName="description sp-space">
                  ライティングの基礎力を身につけ、それを活かしていくための「写真」や「ブランディング」など見せ方・届け方の視点、さらにお仕事への繋げ方も学んでいくセットです。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallContentsMarketingCard />
                      <CourseSmallBrandingCard />
                      <CourseSmallCameraCard />
                      <CourseSmallSelfBrandingCard />
                      <CourseSmallWorkTrialCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4930613" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard2} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン3</p>
              {GlobalStatesV3.viewport.isSp && (
                <p styleName={classNames('pattern-label', 'writer')}>
                  ライターとしてお仕事していくために、最短最速で知識をつけたい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isNonSp && (
                  <p styleName={classNames('pattern-label', 'writer')}>
                    ライターとしてお仕事していくために、最短最速で知識をつけたい
                  </p>
                )}
                <p styleName="description sp-space">
                  短期集中でライターデビューするために抑えておきたいライティングに関連するスキル習得に特化したセットです。マーケティング、カメラ、PRなど複数領域も最低限カバーしておくことで、ライターとしてお仕事を獲得しやすくなります。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallMarketingFirstCard />
                      <CourseSmallPrCard />
                      <CourseSmallCopyWritingCard />
                      <CourseSmallCameraCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4930461" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard3} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
